import React from 'react';
import OutstandingReportFunctional from './components/outstanding-report-list-functional';
import './outstanding-report.scss';

const OutstandingReport = () => {
	return <OutstandingReportFunctional />;
};

export default OutstandingReport;
